import { useAxiosPost } from './usePost';
import { RegistUserResponse } from '@project_bamboo/shared';

const useSendReturnMessage = () => {
  return useAxiosPost<RegistUserResponse>('/product/send-return-message');
};

export default useSendReturnMessage;
